<template>
    <ul id="divGenericTreeviewList">
        <tree-item v-for="(item, index) in treeData" :key="index" 
        class="item" :item="item" 
        @make-folder="makeFolder" 
        @delete-item="deleteItem" 
        @handle-cancel="handleCancel"
        @item-link-clicked="itemLinkClicked">
        </tree-item>
    </ul>
</template>

<script>
    import axios from 'axios';
 
    export default {
        name: "document-treeview-vue-component",
        props: {
            keyId: String,
            webService: String
        },
        data: function () {
            return {
                //treeData: treeData
                treeData: [],
                loader: "spinner"
            };
        },
        mounted() {
            //mounted is an event in the lifecyle of a vue component
            this.reset();
        },
        computed() {
            //no computeds yet
        },
        watch: {
            keyId: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.reset();
                }
            },
            webService: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.reset();
                }
            }
        },
        methods: {
            reset(callback) {
                //let vm = this;
                this.treeData = [];
                this.handleGetGenericTreeviewMembers(callback);
            },
            //makeFolder(item) {
                //let vm = this;
                //Vue.set(item, "children", []);
                //vm.addItem(item);
            //},
            async deleteItem(item) {
                // This function is only shown for Patient Partial Form Responses.
                var vm = this;
                if (!this.isFolder) {
                    vm.$swal({
                    title: "Confirm Action",
                    text: "Are you sure you want to delete this form?",
                    icon: "warning",
                    showCancelButton: true
                }).then((result) => { 
                    if (result.isConfirmed) {
                        axios.post("../../Common/Services/EmarClientOperations.svc/" + item.deleteWebService, {
                        formToDeleteString: item.destURL
                    });
                    vm.reset();
                    }
                });
                    
                }
            },
            handleGetGenericTreeviewMembers() {
                let vm = this;
                axios.post("../../Common/Services/EmarClientOperations.svc/" + this.webService, {
                    keyId: this.keyId
                })
                .then((response) => {
                    vm.treeData = JSON.parse(response.data.d);
                    //Ugh...  This is a hack.  I wont to make sure the tb_show is taken off after loading the popup.
                    //TODO:  Add the blockUI plugin to the Vue environment, so that I can handle this correctly. 
                    // eslint-disable-next-line no-undef
                    tb_remove();
                });
                //console.log(JSON.parse(result.data.d));
            },
            itemLinkClicked(item) {
                let vm = this;

                if (item.openInNewWindow) {
                    window.open(item.destURL, '_blank', item.windowSetting);
                }
                else {
                    window.location.href= item.destURL;
                }
                
                vm.$emit("closeTreeView");
            },
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .item {
        cursor: pointer;
        font: normal 12px "Roboto", sans-serif;
    }

    .bold {
        font-weight: bold;
        color: lightgray;
    }

    #divGenericTreeviewList {
        overflow: auto; 
        text-align: left;  
        color: white;
    }

    #divGenericTreeviewList ul{margin-left:1em}
</style>
